import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-400" }, null, -1)
const _hoisted_2 = { class: "text-gray-lp-500 text-12px py-2" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "w-1/3 flex flex-col mr-6" }
const _hoisted_5 = { class: "w-1/3 flex flex-col" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "border-t border-gray-lp-400" }, null, -1)
const _hoisted_7 = { class: "text-gray-lp-500 text-12px py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_AddLayout = _resolveComponent("AddLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AddLayout, {
      onBack: _ctx.goBack,
      onTryAgain: _ctx._onCreate,
      isDisabled: _ctx.isDisabled,
      isConfirm: _ctx.isOpenConfirm,
      isSuccess: _ctx.isSuccess,
      onConfirmSave: _ctx.onOpenConfirm,
      onSave: _ctx._onCreate,
      keyName: _ctx.form.name
    }, _createSlots({ _: 2 }, [
      (!_ctx.isLoading)
        ? {
            name: "data",
            fn: _withCtx(() => [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('announcement.nameActivity'),
                class: "w-4/5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpInput, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                    placeholder: _ctx.$t('announcement.placeholderName'),
                    maxLength: "56",
                    showMaxLength: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('announcement.description')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TextEditor, {
                    modelValue: _ctx.form.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.description = $event)),
                    placeholder: _ctx.$t('announcement.placeholderDescription'),
                    maxLength: _ctx.form.maxLength,
                    class: "my-2"
                  }, null, 8, ["modelValue", "placeholder", "maxLength"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('announcement.attachment'),
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadFile, {
                    modelValue: _ctx.form.attachment,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.attachment = $event)),
                    type: "pdf",
                    maxSize: 16
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: "Banner",
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadImage, {
                    modelValue: _ctx.form.bannerImage,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.bannerImage = $event)),
                    maxSize: 5,
                    caption: _ctx.$t('announcement.maxSizeFormatBanner')
                  }, null, 8, ["modelValue", "caption"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('announcement.releaseDate'),
                class: "flex flex-col w-3/5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DatePickerV2, {
                    modelValue: _ctx.releasedDate,
                    modelValueTime: _ctx.releasedDateTime,
                    onSelected: _ctx.inputDateStart,
                    onSelectedTime: _ctx.inputDateStartTime,
                    minDate: _ctx.yesterdayDate,
                    showTimePicker: "",
                    class: "my-2"
                  }, null, 8, ["modelValue", "modelValueTime", "onSelected", "onSelectedTime", "minDate"]),
                  _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }, _toDisplayString(_ctx.$t('announcement.invalidReleaseDate')), 513), [
                    [_vShow, _ctx.invalidDate]
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _hoisted_1,
              _createVNode(_component_DataWrapper, { label: "Target" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('announcement.selectTargetHint')), 1),
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listTargetUser.slice(0, 3), (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: index === _ctx.listTargetUser.length - 1 && 'pb-2'
                        }, [
                          _createVNode(_component_Checkbox, {
                            item: item,
                            index: index,
                            length: _ctx.listTargetUser.length,
                            keyName: "name",
                            isSelected: _ctx.isSelected,
                            onChooseSelect: _ctx.onChooseSelect
                          }, null, 8, ["item", "index", "length", "isSelected", "onChooseSelect"])
                        ], 2))
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_5, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listTargetUser.slice(3), (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: index === _ctx.listTargetUser.length - 1 && 'pb-2'
                        }, [
                          _createVNode(_component_Checkbox, {
                            item: item,
                            index: index,
                            length: _ctx.listTargetUser.length,
                            keyName: "name",
                            isSelected: _ctx.isSelected,
                            onChooseSelect: _ctx.onChooseSelect
                          }, null, 8, ["item", "index", "length", "isSelected", "onChooseSelect"])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_6,
              _createVNode(_component_DataWrapper, { label: "Tandai Pesan" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('announcement.pinnedHint')), 1),
                  _createVNode(_component_Toggle, {
                    modelValue: _ctx.isPinned,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isPinned = $event)),
                    textActive: _ctx.$t('announcement.pinnedYes'),
                    textInactive: _ctx.$t('announcement.pinnedInactive')
                  }, null, 8, ["modelValue", "textActive", "textInactive"])
                ]),
                _: 1
              })
            ])
          }
        : undefined
    ]), 1032, ["onBack", "onTryAgain", "isDisabled", "isConfirm", "isSuccess", "onConfirmSave", "onSave", "keyName"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('announcement.confirmLeaveTitle'),
      message: _ctx.$t('announcement.confirmLeaveMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('announcement.leave'),
      textCancel: _ctx.$t('announcement.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ])
  ], 64))
}